import Highway from "@dogstudio/highway";
import CookieForm from "../components/cookieForm";

let cookiesObject = {};

class cookies extends Highway.Renderer {
  onEnter() {}

  onEnterCompleted() {
    cookiesObject.cookieForm = new CookieForm();
  }

  onLeave() {}

  onLeaveCompleted() {
    if (typeof cookiesObject.cookieForm !== "undefined")
      cookiesObject.cookieForm.destroy();
    cookiesObject = {};
  }
}

export default cookies;



// WEBPACK FOOTER //
// ./scripts/routes/page-cookies.js